import React from 'react';

interface Props {
  children: React.ReactNode;
  onClick: (event?: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
}

const DropdownToggle = React.forwardRef(({ children, onClick }: Props, ref: React.ForwardedRef<HTMLSpanElement>) => (
  <span
    ref={ref}
    style={{ display: 'inline-block' }}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </span>
));

DropdownToggle.displayName = 'DropdownToggle';

export default DropdownToggle;
